<template lang="pug">
	content-page
		div(slot="nav")
			navigation-default
			//- areas-filter-list(v-model="filterstring")
			//- nuxt-link(:to="localePath('areas-countries')") {{$t('page.areas:navlist.countries')}}
		div
			h1 {{contentpage.name}}
			ws-content(:value="contentpage.content")
				v-divider
				areas-list(:sort="{ ascending: false, field: 'RELEVANCE' }" limit="50" hide-show-all)
</template>

<script>
import gql from 'graphql-tag';
import AreasList from '@/components/areas/list.vue';
import NavigationDefault from '@/components/navigation-default';

import Content from '@dengl/common/components/content.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
const areasIndexQuery = gql`
	query getAreasIndexWithPath($path: String!) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			parent {
				id
				name
				slug
				path
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden/top50',
			'de-DE': '/skigebiete/top50',
			'nl-BE': '/skigebieden/top50'
		}
	},
	components: {
		AreasList,
		NavigationDefault
	},
	asyncData({ app, error, route }) {
		app.ads({});
		return app.$graphClient
			.query({
				query: areasIndexQuery,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}
				if (!data.contentpage) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				app.meta(data.contentpage.meta);
				if (data.contentpage.parent) {
					app.breadcrumbs({
						[data.contentpage.parent.name]: {
							name: 'contentpage',
							params: { 0: data.contentpage.parent.path.slice(1) }
						},
						[data.contentpage.name]: {
							name: 'contentpage',
							params: { 0: route.path.slice(1) }
						}
					});
				} else {
					app.breadcrumbs({
						[data.contentpage.name]: {
							name: 'contentpage',
							params: { 0: route.path.slice(1) }
						}
					});
				}
				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'areas-index-01', error);
			});
	},
	data() {
		return {
			filterstring: '',
			sort: {
				ascending: false,
				field: 'RELEVANCE'
			},
			total: null
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
